import { Component, OnInit } from '@angular/core';
import {
  DashboardService,
  ClaimDashBoardMetrics,
  DashboardKpiService,
  GlobalVariablesService
} from '@tmhcc-ng-lib/data-service';

import { Router, ActivatedRoute } from '@angular/router';
import { SubCompanyService, SubCompany } from '@tmhcc-ng-lib/data-service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import {
  InputConfig,
  FieldTypes,
  FieldInfo
} from '@tmhcc-ng-lib/framwork/form-inputs';
import { BusinessInfoConfig } from './tab-cofig';
import { DateService } from '@tmhcc-ng-lib/framwork/services';
import { has } from 'libs/util/has-value';
import { Subscription } from 'rxjs';
import { CoreInputValidationService } from '@tmhcc-ng-lib/framwork/core-inputs';
import { KpiContentService } from '@tmhcc-ng-lib/content-service';
import { DatePipe } from '@angular/common';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';

@Component({
  selector: 'ac-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  providers: [DatePipe]
})
export class TabsComponent extends BusinessInfoConfig implements OnInit {
  valueSub = new Subscription();
  frmGroup: FormGroup;
  showComponent: string;
  rightTab: any;
  badges: any;
  selectedSubComp: any;
  subCompanyList: SubCompany[];
  yeartoyear: any;
  sixMonth: any;
  tweleveMonths: any;
  masterData: any;
  tabloading = false;
  fieldGroupName: FormGroup;
  dropDownValue: any;
  submissionCount: number;
  quotedCount: number;
  claimsIncurred: number;
  ratio: number;
  claimPaid: number;
  commissionPaid: number;
  gwpAmt: any;
  selectedTab: any;
  ytd: boolean;
  frmDate: any;
  toDate: any;
  fromDatepickerInfo: FieldInfo = {
    placeholder: 'Start Date',
    fieldName: 'fromDate',
    label: 'Date Picker',
    fieldType: FieldTypes.Date,
    showLabel: false,
    validations: {
      required: 'Please select a from date'
    }
  };
  toDatepickerInfo: FieldInfo = {
    fieldName: 'toDate',
    label: 'Date Picker',
    placeholder: 'End Date',
    fieldType: FieldTypes.Date,
    showLabel: false,
    validations: {
      required: 'Please select a to date'
    }
  };
  dateFromConfig: InputConfig;
  dateToConfig: InputConfig;
  tabsContentLabel: any;
  tabsMenu: any;
  tab1: string;
  tab2: string;
  tab3: string;
  tab4: string;

  constructor(
    private validationService: CoreInputValidationService,
    private dashboard: DashboardService,
    private dashboardKPIService: DashboardKpiService,
    private subCompanyService: SubCompanyService,
    private router: Router,
    private routes: ActivatedRoute,
    private dateservice: DateService,
    private fb: FormBuilder,
    private SiteCoreData: KpiContentService,
    private datePipe: DatePipe,
    private globalVarService: GlobalVariablesService
  ) {
    super(dateservice);
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }
  fields: InputConfig[];

  ngOnInit(): void {
    this.showComponent = 'yearToDate';
    this.fields = this.BusinessInfo;
    this.masterData = this.routes.snapshot.data['dashboard']['masterData'];
    this.selectedTab = 12;
    this.ytd = true;
    this.toDate = this.formatDate(new Date());
    this.fieldGroupName = this.fb.group({
      claimAttorny: new FormControl(null)
    });

    this.subCompanyService.updateSelectedSubCompanyCode(
      this.router.url,
      this.selectedSubComp,
      this.subCompanyList
    );
    this.dateFromConfig = {
      config: {
        datePickerConfig: {
          dateInputFormat: this.dateService.getFormat(),
          isCalanderRequired: true
        }
      },
      fieldInfo: this.fromDatepickerInfo
    };
    this.dateToConfig = {
      config: {
        datePickerConfig: {
          dateInputFormat: this.dateService.getFormat(),
          isCalanderRequired: true
        }
      },
      fieldInfo: this.toDatepickerInfo
    };
    this.initFormGroup();
    this.dashboardKPIData();
    this.getKPISiteCoreData();
  }
  getKPISiteCoreData() {
    this.SiteCoreData.data$.subscribe(res => {
      if (res) {
        this.tabsMenu = res.tabMenu;
        this.tabsContentLabel = res.tabLabels;
      }
    });
  }

  dashboardKPIData() {
    this.tabloading = true;
    const payload = {
      SubCompanyList: 'ARC,AXL,CE,BR,RAM',
      PolicyTypeList: '10148,10223,10235,10222,10205',
      AgentContactId: null,
      AgencyContactId: this.globalVarService.agencyId,
      YTD: this.ytd,
      MonthsToInclude: this.selectedTab,
      FrmDt: this.frmDate,
      ToDt: this.toDate
    };

    this.dashboardKPIService.getDashboardKPIData(payload).subscribe(data => {
      this.tabloading = false;

      if (data) {
        this.submissionCount = data.SubmissionCount;
        this.quotedCount = data.BoundCount;
        this.ratio = data.ConversionRatio * 100;
        this.claimPaid = data.CommissionsPaid;
        this.gwpAmt = data.GrossWrittenPremium;
        this.commissionPaid =
          data.ClaimsIncurred / data.GrossWrittenPremium || 0;
      }
    });
  }
  initFormGroup() {
    const controls = {};

    controls[this.fromDatepickerInfo.fieldName] = ['', Validators.required];

    controls[this.toDatepickerInfo.fieldName] = ['', Validators.required];

    this.frmGroup = this.fb.group(controls);
  }
  clickNavBar(selectedValue: string) {
    this.showComponent = selectedValue;
    if (this.showComponent == 'pastSixMonth') {
      this.selectedTab = 6;
      this.ytd = false;
      this.frmDate = null;
      this.toDate = this.formatDate(new Date());;
      this.dashboardKPIData();
    } else if (this.showComponent == 'pastYear') {
      this.selectedTab = 12;
      this.ytd = false;
      this.frmDate = null;
      this.toDate = this.formatDate(new Date());;
      this.dashboardKPIData();
    } else if (this.showComponent == 'yearToDate') {
      this.selectedTab = 12;
      this.ytd = true;
      this.frmDate = null;
      this.toDate = this.formatDate(new Date());
      this.dashboardKPIData();
    } else {
      this.selectedTab = 12;
      this.ytd = false;
      this.frmDate = null;
      this.toDate = null;
      this.tabloading = false;
    }
  }
  getCustomPage(pageName: string) {
    this.showComponent = pageName;
  }
  searchKpi() {
    this.validationService.setFormSubmission(true);
    this.ytd = false;
    this.frmDate = this.formatDate(this.frmGroup.value.fromDate);
    this.toDate = this.formatDate(this.frmGroup.value.toDate);
    this.selectedTab = null;
    this.dashboardKPIData();
  }
  formatDate(date) {
    return this.datePipe.transform(new Date(date), 'yyyy-MM-dd'); 
  }
}
